import Api from './axios';

// Lists take the filters documented in social/rest/ads.py and return { count, next, previous, results }
const AdsApi = {
  accounts: (params) => Api.get('/ads/accounts/', { params }),
  updateAccount: (id, data) => Api.patch(`/ads/accounts/${id}/`, data),
  campaigns: (params) => Api.get('/ads/campaigns/', { params }),
  adsets: (params) => Api.get('/ads/adsets/', { params }),
  ads: (params) => Api.get('/ads/ads/', { params }),
  // status filter groups: { results: [{ value, label, tone }] }; type 'ad_account' for ad account statuses
  statuses: (type) => Api.get('/ads/statuses/', { params: type ? { type } : {} }),
  insights: (params) => Api.get('/ads/insights/', { params }),
  // a plain link: the browser downloads the CSV with the session cookie
  insightsExportUrl: (params) => `/api/ads/insights/export/?${new URLSearchParams(params)}`,
};

export default AdsApi;
